<template>
  <div>

    <!-- MOBILE TOOLBAR -->
    <div v-if="$vuetify.breakpoint.xs" :class="['c-flex-c mobile-top-bar']">
      <div class="c-flex-r align-center">
        <v-btn
        icon
        rounded 
        @click="goBack">
          <v-icon color="color1">arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <span class="text-ellipsed">
          New Definition
        </span>
        <v-spacer></v-spacer>

        <!-- save button -->
        <transition mode="out-in" name="scale-transition">
          <v-btn
          v-if="isDirty"
          key="1"
          icon
          flat
          :loading="saving"
          @click="validateForm">
            <v-icon color="color1" >check</v-icon>
          </v-btn>

          <v-btn
          v-else
          key="2"
          icon
          flat
          disabled>
            <v-icon>check</v-icon>
          </v-btn>
        </transition>

      </div>
    </div>

    <!-- PC TOOLBAR -->
    <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">
      <v-breadcrumbs class="pl-0">
        <v-breadcrumbs-item to="/dashboard/">
          Home
        </v-breadcrumbs-item>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item to="/inventory/inventory-definitions" exact>
          Inventory definitions
        </v-breadcrumbs-item>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item disabled>
          New
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      
      <div class="c-flex-r align-center">
        <v-btn
        icon
        rounded 
        @click="goBack">
          <v-icon color="color1">arrow_back</v-icon>
        </v-btn>
        <div class="headline text--text text--lighten-1">
          New definition
        </div>
      </div>
      <div class="c-flex-r align-center">
      <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="80px">
        <!-- save button -->
        <div style="min-height: 36px;" class="ml-2">
          <transition mode="out-in" name="scale-transition">
            <v-btn
            v-if="isDirty"
            key="1"
            color="color1"
            class="white--text ma-0"
            :loading="saving"
            @click="validateForm">
            Create
            </v-btn>
          </transition>
        </div>
      </div>
    </div>


    <!-- MAIN CONTENT -->
    <v-layout column
    :class="[{'pl-4': !$vuetify.breakpoint.xs}]"
    style="flex: 1;position: relative; overflow: auto;">
      <edit-form 
      ref="form"
      :isDirty.sync="isDirty"></edit-form>
    </v-layout>

    <!-- dialog -->
    <v-dialog v-model="dialogSaved" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Definition created!!</v-card-title>
        <v-card-text>A new definition has been created.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined @click="redirectToEditPage">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import EditDefinitionForm from './components/EditForm'

export default {
  components: {
    'edit-form': EditDefinitionForm
  },
  data () {
    return {
      dialogSaved: false,
      previousPage: '',
      isDirty: false,
      saving: false,
      savedID: null
    }
  },
  methods: {
    goBack () {
      this.$router.replace(this.previousPage)
    },
    validateForm () {
      var valid = this.$refs.form.validateForm()
      if (valid) {
        console.log('Invalid')
      } else {
        this.createItem()
      }
    },
    open () {
      this.$refs.form.new()
    },
    createItem () {
      this.saving = true
      this.error = ''
      var data = JSON.parse(JSON.stringify(this.$refs.form.formData))
      data.mass = data.mass || 0 // If null set it to zero so MariaDB doesnt throw an error
      data.volume = data.volume || 0
      data.length = data.length || 0
      this.$axios.post('inventory-definitions/create',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            console.log('this is the response')
            console.log(response)
            // this.$refs.form.lastSaved = JSON.stringify(data)
            this.savedID = response.data.id
            this.dialogSaved = true
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.saving = false
        })
    },
    redirectToEditPage () {
      this.$router.replace({ path: `/inventory/inventory-definitions/edit/${this.savedID}`})
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousPage = from.path === '/loading' ? '/inventory/inventory-definitions' : from.path
      next()
    })
  }
}
</script>
